
var Sticky = require('./dist/sticky.compile.js');

module.exports = Sticky;



//////////////////
// WEBPACK FOOTER
// ./~/sticky-js/index.js
// module id = 57
// module chunks = 0